<h3>{{ 'common.labels.parties' | transloco }}</h3>
<!-- SecuredParties -->
@if (uiConfiguration?.hasBusinessParties) {
  <div class="flex-container no-margin">
    <lib-parties-list
      partyTypeTitle="Party"
      [order]="order"
      [observableParties$]="parties$"
      [errors$]="observableErrors$"
      class="flex-item"
      [isEditable]="isEditable"
      [businessPartyType]="businessPartyType"
      [individualPartyType]="individualPartyType"
      [defaultPartyType]="individualPartyType"
      [uiConfiguration]="uiConfiguration!.businessPartyConfiguration!"
      [expandedParty]="newParty"
      (partyAddedEvent)="handlePartyAddedEvent($event)"
      (reusablePartySavedEvent)="handleExistingPartySaveEvent($event)"
      (partyUpdatedEvent)="handlePartySavedEvent($event)"
      (partyCopiedEvent)="handlePartyCopiedEvent($event)"
      (partyRemovedEvent)="handlePartyRemovedEvent($event)"
      (partyFormValueChangedEvent)="handlePartyFormValueChangedEvent($event)">
    </lib-parties-list>
  </div>
}